module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C72_4"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C83"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/04_A_Note_o#page_vii"
    }
  }, [_vm._v("A Note on Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "C72"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_An_Image#page_1"
    }
  }, [_vm._v("An Image of God, Not a Mere Animal: An Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C85_5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_One___Fo#page_13"
    }
  }, [_vm._v("ONE. For the Welfare of the Race: The Early Clash over Reproduction and Community")])]), _vm._v(" "), _c('p', {
    staticClass: "C85_5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Two___Co#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO. Cooperative Clergy? Catholics in the American Eugenics Society")])]), _vm._v(" "), _c('p', {
    staticClass: "C85_5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Three__#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE. Practical Means: Catholic Strategies for Protesting Sterilization Statutes")])]), _vm._v(" "), _c('p', {
    staticClass: "C85_5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Four___S#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOUR. Supreme Authorities: Catholicism and Eugenics beyond the Borders")])]), _vm._v(" "), _c('p', {
    staticClass: "C85_5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Five___T#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE. The Greatest Obstacle: The Growth of a Confident Opposition")])]), _vm._v(" "), _c('p', {
    staticClass: "C85_5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Six___A#page_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIX. A Great, Popular, Noncontroversial, and Effective Movement: Struggling with the “New Eugenics”")])]), _vm._v(" "), _c('p', {
    staticClass: "C72"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Epilogue#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Acknowle#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Notes#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Bibliogr#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Index#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4270b4f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Contents.vue
// module id = 63
// module chunks = 0